import React from 'react';
import { motion } from 'framer-motion';
import ThemeToggle from './ThemeToggle';
import { useTheme } from '../contexts/ThemeContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMessageCircle } = FiIcons;

const Header = () => {
  const { isDark } = useTheme();

  const handleQuoteClick = () => {
    window.open('https://angrybranding.com/#request-a-quote', '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className={`sticky top-0 z-50 backdrop-blur-md border-b transition-colors duration-300 ${
        isDark 
          ? 'bg-gray-900/80 border-gray-800' 
          : 'bg-white/80 border-gray-200'
      }`}
    >
      <div className="px-3 sm:px-4 py-3 sm:py-4">
        <div className="flex items-center justify-between">
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="flex items-center space-x-2 sm:space-x-3"
          >
            <img
              src="https://content.app-sources.com/s/51111663627105881/uploads/Downloaded/Untitled_design-9908745.png"
              alt="Angry Branding Logo"
              className="h-8 sm:h-12 w-auto"
            />
            <div>
              <h1 className={`text-lg sm:text-2xl font-black ${isDark ? 'text-white' : 'text-gray-900'}`}>
                ANGRY <span className="text-orange-500">BRANDING</span>
              </h1>
              <p className={`text-xs sm:text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                Apps Showcase
              </p>
            </div>
          </motion.div>

          <div className="flex items-center space-x-2 sm:space-x-4">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleQuoteClick}
              className="flex items-center space-x-1 sm:space-x-2 px-3 sm:px-6 py-2 sm:py-3 bg-orange-500 text-white rounded-full hover:bg-orange-600 transition-colors font-semibold text-sm sm:text-base shadow-lg shadow-orange-500/25"
            >
              <SafeIcon icon={FiMessageCircle} className="w-4 h-4 sm:w-5 sm:h-5" />
              <span className="hidden sm:inline">Get Quote</span>
              <span className="sm:hidden">Quote</span>
            </motion.button>
            <ThemeToggle />
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;